import React from 'react';
import { ListItem } from '../../../../../Components/List';
import { ProductThumb } from '../../../../../Components/Product/ProductThumb';
import IconBtn from '../../../../../Components/IconBtn';
import { IconTooltip } from '../../../../../Components/Tooltip/IconTooltip';
import { PinnedShopifyProduct } from './ShopifyManualSortingTypes';

type ShopifyManualSortingProductItemType = {
	onDelete: () => void,
	onEdit: () => void,
	item: PinnedShopifyProduct,
	error: { hasEror: boolean, message?: string | null }
}

export function ShopifyManualSortingProductItem({
	onDelete,
	onEdit,
	item,
	error
}: ShopifyManualSortingProductItemType) {

	return (
		<ListItem
			className="flex"
			text={item.product.name}
			textIsBold={false}
			description={item.product.id}
			picto={
				<ProductThumb
					url={item.product.urlThumbnail ?? ''}
					alt={item.product.name}
					hasMargin={false}
					width={50}
				/>
			}
			value={
				<div style={{
					borderRight: 'solid 1px var(--main-border-color)',
					paddingRight: 20
				}}>
					{error.hasEror &&
						<IconTooltip
							icon="fas fa-exclamation-triangle"
							tooltip={error.message}
							color='alert'
						/>
					}
					#{item.position + 1}
				</div>
			}
			actions={
				<>
					<IconBtn
						onClick={() => onEdit()}
						icon="fas fa-pen"
						tooltip="Edit product position"
					/>
					<IconBtn
						onClick={() => onDelete()}
						icon="fas fa-trash"
						tooltip="Remove product"
						hoverColor="alert"
					/>
				</>
			}
		/>
	);
} 